import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { of } from 'rxjs';
import {
  setupTypes as types,
  LoadAnticipatedExpendituresAction,
  LoadAnticipatedExpendituresSuccessAction,
  LoadAnticipatedExpendituresFailsAction,
  SetupFiscalYearAction,
  SetupFiscalYearSuccessAction,
  SetupFiscalYearFailsAction,
  SkipFiscalYearSetupAction, SkipFiscalYearSetupSuccessAction, SkipFiscalYearSetupFailsAction
} from './setup.actions';
import { SetupService } from '../shared/services/setup.service';
import { PropertyComponentGroup } from '../../plans/shared/models';
import { catchError, map, mergeMap } from 'rxjs/operators';

@Injectable()
export class SetupEffects {

  constructor(
    private actions$: Actions,
    private setupService: SetupService) { }

  // Anticipated Expenditures
  loadAnticipatedExpenditures$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(types.LOAD_ANTICIPATED_EXPENDITURES),
      map(action => (action as LoadAnticipatedExpendituresAction).payload),
      mergeMap((request) =>
        this.setupService
          .getAnticipatedExpenditures(request.propertyId, request.fiscalYear)
          .pipe(
            map((response: PropertyComponentGroup) => new LoadAnticipatedExpendituresSuccessAction(response)),
            catchError((error) => of(new LoadAnticipatedExpendituresFailsAction(error)))
          )
      )
    );
  });

  // Aging  
  setupFiscalYear$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(types.SETUP_FISCAL_YEAR),
      map(action => (action as SetupFiscalYearAction).payload),
      mergeMap((request) =>
        this.setupService
          .setupFiscalYear(request)
          .pipe(
            map((response: any) => new SetupFiscalYearSuccessAction(response)),
            catchError((error) => of(new SetupFiscalYearFailsAction(error)))
          )
      )
    );
  });

  skipFiscalYearSetup$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(types.SKIP_FISCAL_YEAR_SETUP),
      map(action => (action as SkipFiscalYearSetupAction).payload),
      mergeMap((request) =>
        this.setupService
          .skipFiscalYearSetup(request.propertyId, request.fiscalYear)
          .pipe(
            map((response) => new SkipFiscalYearSetupSuccessAction(response)),
            catchError((error) => of(new SkipFiscalYearSetupFailsAction(error)))
          )
      )
    );
  });

  // @Effect({dispatch: false})
  // skipFiscalYearSetupSuccess$: Observable<Plan> = this.actions$.pipe(
  //     ofType(types.SKIP_FISCAL_YEAR_SETUP_SUCCESS),
  //     map(action => (action as SkipFiscalYearSetupSuccessAction).payload),
  //     tap( () => {
  //         this.router.navigateByUrl('/useraccount/plans');
  //     })
  // );
}
